module.exports = __webpack_public_path__ + "static/img/jijinhui01.5001f6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/jijinhui01.jpg
// module id = EDoa
// module chunks = 0